/*  ==========================================================================
    ROOMS DETAIL
    ========================================================================== */

/*
 * IMPORTS
 */

// node modules imports
import $ from 'jquery';

import * as vars from '../../globals/variables';

$('.bn-quote__items').slick({
    dots: false,
    infinite: true,
    nextArrow: vars.slick_nextArrow,
    prevArrow: vars.slick_prevArrow,
    autoplay: true,
    autoplaySpeed: 5000,

});


// WEBPACK FOOTER //
// ./source/js/modules/lib/quotes.js